module.exports = __webpack_public_path__ + "0f7b54405b700c777d056dc833e62380.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/alert-big.svg
// module id = 1233
// module chunks = 65